import { render, staticRenderFns } from "./FormBuilder.vue?vue&type=template&id=5aa56a2b"
import script from "./FormBuilder.vue?vue&type=script&lang=ts"
export * from "./FormBuilder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports